export default __webpack_public_path__ + "static/media/graphic_hubmobile.5f04523c.png";